// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__33xet","tab":"Tabs_tab__3QHPS","tabActive":"Tabs_tabActive__2MKAW"};